export default __webpack_public_path__ + "static/bg-texture-1a11f28299d9ef78487ad4298180506a.jpg";